<template>
    <div class="loading-screen-tutorial text-center">
        <a-tabs :prefixCls="$prefixClass.tabs" :class="[$prefixClass.tabs+'-border']" v-model="activeKey" tabPosition="bottom">
            <a-tab-pane key="google">
                <img class="google" slot="tab" src="@/assets/images/icons/google.svg"/>
                <div class="tutorial-video">
                    <iframe loading="lazy" src="//www.youtube.com/embed/Hj9hIaHQhpM?autoplay=1" width="100%"
                        height="100%" frameborder="0" allowfullscreen
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        :srcdoc="googleSrcdoc +
                            `<script>
                                function thumbnailOnclick() {
                                    window.parent.postMessage('google', '*');
                                };
                            </script>`">
                        </iframe>
                    <div v-if="!googleOnclick" class="tutorial-video__note">
                        <span class="fz-14">
                            {{ $t('loading_screen.components.demo_from') }}
                        </span>
                        <img class="google m-l-8" src="@/assets/images/icons/google.svg" />
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="linkedin">
                <img class="linkedin" slot="tab" src="./../assets/icons/linkedin.svg"/>
                <div class="tutorial-video">
                    <iframe loading="lazy" src="//www.youtube.com/embed/90xtpbswG88?autoplay=1" width="100%"
                        height="100%" frameborder="0" allowfullscreen
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        :srcdoc="linkedinSrcdoc +
                            `<script>
                                function thumbnailOnclick() {
                                    window.parent.postMessage('linkedin', '*');
                                };
                            </script>`">
                        </iframe>
                    <div v-if="!linkedinOnclick" class="tutorial-video__note">
                        <span class="fz-14">
                            {{ $t('loading_screen.components.demo_from') }}
                        </span>
                        <div class="linkedin">
                            <img src="@/assets/images/icons/linkedin.svg" />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="twitter">
                <img class="twitter" slot="tab" src="./../assets/icons/twitter.svg"/>
                <div class="tutorial-video">
                    <iframe loading="lazy" src="//www.youtube.com/embed/AkHmrBsQu34?autoplay=1" width="100%"
                        height="100%" frameborder="0" allowfullscreen
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        :srcdoc="twitterSrcdoc +
                            `<script>
                                function thumbnailOnclick() {
                                    window.parent.postMessage('twitter', '*');
                                };
                            </script>`">
                        </iframe>
                    <div v-if="!twitterOnclick" class="tutorial-video__note">
                        <span class="fz-14">
                            {{ $t('loading_screen.components.demo_from') }}
                        </span>
                        <div class="twitter">
                            <img src="@/assets/images/icons/twitter.svg" />
                        </div>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
        <div class="tutorial-content">
            <h5 class="m-0 m-t-32"> {{ title }} </h5>
            <span :class="[start ? 'text-color-secondary' : '']">{{ description }}</span><br>
            <!-- <a v-if="!start" class="a-link" href="" target="_blank">{{$t('app.buttons.learn_more')}}</a> -->
            <a-button class="m-t-16" type="primary" @click="onLetStart"> {{ btnText }}</a-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'LoadingScreenTutorial',
        props: {
            active: {
                type: Boolean,
                default: false
            },
            start: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                activeKey: 'google',
                googleOnclick: false,
                linkedinOnclick: false,
                twitterOnclick: false,
                googleSrcdoc: `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style>
                        <a href=https://www.youtube.com/embed/Hj9hIaHQhpM?autoplay=1 onclick='thumbnailOnclick();'><img style='background-color: #000000; opacity: 70%;' src=${require(`@/assets/thumnails/google.jpg`)} alt='Video'><span>▶</span></a>`,
                linkedinSrcdoc: `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style>
                        <a href=https://www.youtube.com/embed/90xtpbswG88?autoplay=1 onclick='thumbnailOnclick();'><img style='background-color: #000000; opacity: 70%;' src=${require(`@/assets/thumnails/linkedin.jpg`)} alt='Video'><span>▶</span></a>`,
                twitterSrcdoc: `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style>
                        <a href=https://www.youtube.com/embed/AkHmrBsQu34?autoplay=1 onclick='thumbnailOnclick();'><img style='background-color: #000000; opacity: 70%;' src=${require(`@/assets/thumnails/twitter.jpg`)} alt='Video'><span>▶</span></a>`
            }
        },
        computed: {
            title() {
                if ( !this.start ) return this.$t('loading_screen.components.watch_demo')
                if ( this.active ) return this.$t('loading_screen.components.start_title_available')
                return this.$t('loading_screen.components.start_title_unavailable')
            },
            description() {
                if ( !this.start || this.active ) return this.$t('loading_screen.components.start_description_available')
                return this.$t('loading_screen.components.start_description_unavailable')
            },
            btnText() {
                if ( !this.start ) return this.$t('loading_screen.buttons.i_got_it')
                if ( this.active ) return this.$t('loading_screen.buttons.custom_screen')
                return this.$t('app.buttons.upgrade_now')
            }
        },
        mounted() {
            window.addEventListener("message", this.handleEvent, false);
        },
        methods: {
            onLetStart() {
                if ( !this.start ) {
                    this.$emit('got-it')
                } else {
                    if (this.active) {
                    this.$emit('let-start')
                    } else {
                        this.$router.push({
                            name: this.$routerName.PRICING
                        })
                    }
                }
            },
            handleEvent(message) {
                switch(String(message.data)) {
                    case 'google':
                        this.googleOnclick = true
                    break;
                    case 'linkedin':
                        this.linkedinOnclick = true
                    break;
                    case 'twitter':
                        this.twitterOnclick = true
                    break;
                }
            }
        }
    }
</script>
<style lang="scss">
    .loading-screen-tutorial {
        .m-tabs {
            border-bottom: none;
            &-nav {
                position: relative;
                > div:nth-child(1) {
                    border-bottom: 1px solid $line-color;
                    margin-bottom: 1px;
                }
            }
            &-ink-bar {
                background-color: $primary-color;
                position: absolute;
                bottom: 1px !important;
                top: auto !important;
            }
            &-bottom-bar {
                border-top: unset;
            }
            &-tab {
                img {
                    &.google {
                        width: 58px;
                    }
                    &.linkedin {
                        // width: 70px;
                    }
                    &.twitter {
                        // width: 60px;
                    }
                }
            }
        }
        .tutorial {
            &-video {
                position: relative;
                height: 212px;
                border-radius: 8px 8px 0 0;
                overflow: hidden;
                height: 405px;
                &__note {
                    position: absolute;
                    display: flex;
                    top: 16px;
                    background: $white-color;
                    padding: 8px;
                    padding-right: 14px;
                    border-radius: 0 4px 4px 0;
                    .linkedin {
                        display: flex;
                        margin-left: 8px;
                        width: 60px;
                        height: 20px;
                    }
                    .twitter {
                        display: flex;
                        margin-left: 8px;
                    }
                }

                video {
                    position: absolute;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                    left: 0;
                }
            }

            &-content {
                margin-top: -24px;
                border-radius: 0 0 8px 8px;
                border: 1px solid $line-color;
                border-top-color: $white-color;
                text-align: center;
                padding: 24px 0;
            }
        }
    }
</style>